import React from "react"
import styles from "./AnimatedMeshBackground.module.scss"

interface AnimatedMeshBackgroundProps {
  gridSize?: number
  gridOpacity?: number
}

const AnimatedMeshBackground: React.FC<AnimatedMeshBackgroundProps> = () => {
  return (
    <div className={styles.container}>
    </div>
  )
}

export default AnimatedMeshBackground

